import i18n from 'frontcore/i18n'
import notAuthorizationAPIClient from 'frontend/presentation/not-authorization/data/NotAuthorizationAPIService'
import { computed, reactive, ref } from 'vue'
import { M_LEAN_EMAIL_SUPPORT } from 'frontcore/constants/constants'
import { PersonMin } from 'frontend/presentation/not-authorization/types'
import { store } from 'frontend/store/store'
import { useProfileStore } from 'frontcore/store/useProfileStore'

const useNotAuthorization = () => {
  const { t } = i18n.global

  const profileStore = useProfileStore()
  const administrators = ref<PersonMin[]>([])
  const mailToSupport = `mailto:${M_LEAN_EMAIL_SUPPORT}`
  const { getAdministrators } = notAuthorizationAPIClient()

  const accessMessage = computed(() => {
    return !profileStore.userHasAccessPermission ? t('login.errors.not_authorized') : t('login.errors.not_role_authorized')
  })

  const loadAdministrators = async () => {
    const adminList = await getAdministrators()
    administrators.value = adminList.filter((person) => person.email !== M_LEAN_EMAIL_SUPPORT)
  }

  const logout = () => {
    store.dispatch('resetProfile')
    window.location.replace('/')
  }

  return reactive({
    administrators,
    mailToSupport,
    accessMessage,
    loadAdministrators,
    logout,
  })
}

export default useNotAuthorization
